import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {DateRangeSelectionComponent} from '@Components/date-range-selection/date-range-selection.component';
import {ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { DateRangeHeaderComponent } from './date-range-header/date-range-header.component';
import {MatChipsModule} from "@angular/material/chips";


@NgModule({
  declarations: [
    DateRangeSelectionComponent,
    DateRangePickerComponent,
    DateRangeHeaderComponent
  ],
  exports: [
    DateRangeSelectionComponent,
    DateRangePickerComponent
  ],
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatChipsModule
  ]
})
export class DateRangeSelectionModule { }
